import React, { useState } from "react"

import { action, makeAutoObservable, runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import { joinClasses, changeView, useClasses } from "../globals";
import { signIn, signOut, anonLogin } from "../simgate";

import {
  Box,
  Button,
  ButtonGroup,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"

// Icons
import AutorenewIcon from "@material-ui/icons/Autorenew"
import VisibilityIcon from "@material-ui/icons/Visibility"
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff"
import { CheckBox, CheckBoxOutlineBlank, CheckBoxOutlined, Facebook, GTranslate, Twitter } from "@material-ui/icons"

class ReviewerNickNameStore {

  processing = false;
  nameError = "";
  name = "";
  email = "anonreviewer@regis-co.com"
  remember = true;

  serverError = "";

  constructor(app) {
    makeAutoObservable(this);
    this.app = app;
  }

  async login() {
    const {
      app: {
        reviewerSettings
      },
      name,
      email,
      remember
    } = this;


    runInAction(() => {
      this.processing = true;
    });

    await new Promise(resolve => setTimeout(resolve, 500)); // Artificial timeout to make it seem like something is happening

    if (!this.validateName()) {
      this.processing = false;
      return;
    }

    runInAction(() => {
      reviewerSettings.context.user.firstName = name?.trim()?.split(" ")?.[0];
      reviewerSettings.context.user.lastName = name?.trim()?.split(" ")?.slice(1).join(" ");
      reviewerSettings.context.user.email = email?.trim()?.toLowerCase() || "anonreviewer@regis-co.com";
      
      if (remember) {
        window.localStorage.setItem("STUDIO_REVIEWER_NICKNAME", JSON.stringify({
          firstName: reviewerSettings.context.user.firstName,
          lastName: reviewerSettings.context.user.lastName,
          email: reviewerSettings.context.user.email,
          t: new Date().getTime()
        }))
      }
      
      this.app.context = reviewerSettings.context;
      console.log(reviewerSettings.context);
      //this.processing = false;
    });
  }

  validateName() {
    const { name, email } = this;

    if (!Boolean(name) || name?.trim().length < 1) {
      runInAction(() => this.nameError = "Nickname is required");
      return false;
    }

    if (name.length > 64) {
      runInAction(() => this.nameError = "Nickname must be less than 64 characters long");
      return false;
    }
    
    if (!Boolean(email) || email.length < 3) {
      runInAction(() => this.emailError = "Email is required");
      return false;
    }
    if (email.length > 128) {
      runInAction(() => this.emailError = "Email must be less than 128 characters long");
      return false;
    }
    
    if (!/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(email)) {
      runInAction(() => this.emailError = "Email is invalid");
      return false;
    }

    return true;
  }

}



export const ReviewerNickName = observer(({ app }) => {

  const classes = useClasses();
  const [store] = useState(() => new ReviewerNickNameStore(app));

  const {
    processing,
    nameError,
    name,
    remember,
    serverError,
    email,
    emailError
  } = store;

  const { reviewerSettings } = app;

  if (!Boolean(reviewerSettings?.project)) {
    return <>
      <Box
        className={joinClasses(
          classes._Padding,
          classes._Flex,
          classes._FlexDirectionColumn
        )}
      >
        <Box className={classes._Margin}>
          <Collapse in>
            <Alert severity="error">
              <Typography>
                The project you are looking for could not be found or the provided token is not valid.
              </Typography>
            </Alert>
          </Collapse>
        </Box>
      </Box>
    </>
  }

  return (
    <React.Fragment>
      <Box className={classes._Margin}>
        <Paper>
          <Box
            className={joinClasses(
              classes._Padding,
              classes._TextAlignCenter,
              classes._Flex,
              classes._FlexDirectionColumn
            )}
          >
            <Box className={classes._MarginVertical}>
              <Typography variant="h3">{reviewerSettings?.project?.name}</Typography>
            </Box>
          </Box>
        </Paper>
      </Box>

      <Box
        className={joinClasses(
          classes._Flex,
          classes._FlexDirectionColumn,
          classes._Padding
        )}
      >
        <Box className={classes._Margin}>

          <FormControl fullWidth variant="outlined">
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              disabled={processing}
              label="Nickname"
              type="text"
              value={name}
              onFocus={action(() => {
                store.nameError = "";
              })}
              onChange={action(e => store.name = e.target.value)}
              onKeyPress={(e) => { if (e.charCode === 13) { store.login() } }}
              error={Boolean(nameError) || Boolean(serverError)}
              helperText={nameError || serverError}
            />
            <br/>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              disabled={processing}
              label="Email"
              type="email"
              value={email}
              onFocus={action(() => {
                store.emailError = "";
              })}
              onChange={action(e => store.email = e.target.value)}
              onKeyPress={(e) => { if (e.charCode === 13) { store.login() } }}
              error={Boolean(emailError) || Boolean(serverError)}
              helperText={emailError || serverError}
            />
            <Box className={classes._Margin}>
              <Alert severity="info">
                Your nickname and email are displayed with any comments you write.
              </Alert>
            </Box>
            {nameError && <FormHelperText error>{nameError}</FormHelperText>}
            {emailError && <FormHelperText error>{emailError}</FormHelperText>}
            {serverError && <FormHelperText error>{serverError}</FormHelperText>}
          </FormControl>

          <FormControl fullWidth variant="outlined">
            <Box
              onClick={action(e => store.remember = !remember)}
              style={{ cursor: "pointer", display: "flex" }}
            >
              {remember ? <CheckBoxOutlined /> : <CheckBoxOutlineBlank />}
              <Typography>Remember nickname for 7 days</Typography>
            </Box>
          </FormControl>
        </Box>
      </Box>

      <Box
        className={joinClasses(
          classes._Flex,
          classes._FlexDirectionColumn,
          classes._Padding
        )}
      >
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          startIcon={
            processing ? (
              <AutorenewIcon className={classes.processingIcon} />
            ) : null
          }
          disabled={Boolean(processing)}
          onClick={() => { store.login() }}
        >
          Sign In
        </Button>
      </Box>
    </React.Fragment>
  )
})

ReviewerNickName.title = "";